export default {
  searchContact: 'Rechercher un contact (3 caractères min.)',
  searchError: 'Une erreur est survenue pendant la recherche',
  emptySearch: 'Aucun contact trouvé',
};
